<template>
  <b-row :class="rowClasses" :style="backgroundCss" @click="onClick">
    <b-col cols="12" class="label" :style="labelCss" v-if="label">
      {{ label }}
      <info-popup v-if="info" :value="info" />
    </b-col>
    <b-col cols="12" class="value" :style="valueCss">
      <slot>{{ value }}</slot>
    </b-col>
  </b-row>
</template>

<script>
import InfoPopup from '@/components/Custom/InfoPopup';
import StatMixin from '@/components/Dashboard/StatMixin';

export default {
  name: "StatBox",
  components: {
    InfoPopup,
  },
  mixins: [StatMixin],
  props: {
    info: {
      type: String,
    },
    size: {
      type: String,
      default: 'medium',
    },
    align: {
      type: String,
    },
    divider: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    backgroundCss() {
      if (!this.bgColor) {
        return '';
      }

      return 'background: ' + this.bgColor;
    },
    valueCss() {
      if (!this.color) {
        return '';
      }

      return 'color: ' + this.color;
    },
    labelCss() {
      if (!this.labelColor) {
        return '';
      }

      return 'color: ' + this.labelColor;
    },
    tooltipId() {
      return 'tooltip-' + Math.floor(Math.random() * (999999 - 1)) + 1;
    },
    rowClasses() {
      let cssClass = this.size;
      switch (this.align) {
        case 'right':
          cssClass = cssClass +' text-right';
          break;

        case 'center':
          cssClass = cssClass + ' text-center';
          break;

        default:
          cssClass = cssClass + ' text-left';
          break;
      }

      if (this.clickable || this.to) {
        cssClass = cssClass + ' cursor-pointer';
      }

      if (this.cssClass) {
        cssClass = cssClass + ' ' + this.cssClass;
      }

      return cssClass;
    }
  },
}
</script>

<style scoped>
  .x-small .label {
    font-size: 8px;
    font-weight: 900 !important;
  }
  .x-small .value {
    font-size: 18px;
    font-weight: 900 !important;
    line-height: 18px;
    /*font-family: "MuseoSans-900"*/
  }
  .small .label {
    font-size: 8px;
    font-weight: 900 !important;
  }
  .small .value {
    font-size: 30px;
    font-weight: 900 !important;
    line-height: 30px;
    /*font-family: "MuseoSans-900"*/
  }
  .medium .label {
    font-size: 12px;
    font-weight: 900 !important;
  }
  .medium .value {
    font-size: 48px;
    font-weight: 900 !important;
    line-height: 45px;
    /*font-family: "MuseoSans-900"*/
  }
  .large .label {
    font-size: 12px;
    font-weight: 900 !important;
  }
  .large .value {
    font-size: 72px;
    font-weight: 900 !important;
    line-height: 65px;
    /*font-family: "MuseoSans-900"*/
  }
</style>
